// `new_list_page` gates the redesigned list pages built on `ModelListPage`
// (filter chips, total count, collapsible rows on mobile), starting with
// the user list. Seed migration: amsm-backend
// hall/feature_flags/migrations/0012_seed_new_list_page_flag.py — off for
// every tenant until an administrator turns it on.
export const NEW_LIST_PAGE_FLAG = 'new_list_page'
